<template>
  <div>
    <base-select
      v-model="customerSelectedIndex"
      :items="customersNames"
      label="Select a client"
      placeholder="Search"
      v-on="$listeners"
    >
      <template #default="{items, value, onSelect}">
        <recipients-select
          :communication-type="communication"
          :items="customers"
          :selected="selected"
          hide-groups
          @item-click="onSelect($event.index)"
        />
      </template>
    </base-select>
  </div>
</template>

<script>

export default {
  name: 'ClientSelector',
  props: {
    customers: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Object,
      default: () => {},
    },
    communication: {
      type: String,
      default: 'message',
    },
  },
  data() {
    return {
      customerSelectedIndex: null, // Customer selected (Index)
    };
  },
  computed: {
    customersNames() {
      return this.customers.map((i) => this.associateName(i));
    },
  },
  watch: {
    customerSelectedIndex(value) {
      this.$emit('select', this.customers[value]);
    },
  },
  methods: {
    associateName(associate) {
      if (associate !== undefined) {
        if (
          ((associate.first_name || '').length + (associate.last_name || '').length)
          > 0) return `${associate.first_name || ''} ${associate.last_name || ''}`;
        else return associate.email;
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
